@if (appFacadeService.getContractsTotal() | async; as total) {
<div class="multipayment-panel">
    <por-overlay [layout]="'right-panel'" [featureName]="'multiple-payment-panel'" [isOpen]="isOpen" [trigger]="trigger" (closeOverlayClick)="closeOverlayClick()">
        <div class="multipayment-panel-wrapper mb-2 mt-2">
            @if (appFacadeService.getSelectedNonCreditContracts() | async; as contracts) {
            <ng-container [ngTemplateOutlet]="selectedContract" [ngTemplateOutletContext]="{ $implicit: contracts }"></ng-container>
            } @if (appFacadeService.getSelectedCreditContracts() | async; as contracts) {
            <ng-container [ngTemplateOutlet]="selectedCredits" [ngTemplateOutletContext]="{ $implicit: contracts }"></ng-container>
            }
            <ng-container [ngTemplateOutlet]="totalContracts"></ng-container>
            @if (total < 1) {
            <div class="warnings text-align-center">
                <p>{{ 'PayMinimumAmountDueToProcessPayment1' | translate }} {{ '1' | formatCurrency }} {{ 'PayMinimumAmountDueToProcessPayment2' | translate }}</p>
            </div>
            } @if (appFacadeService.isMaxContractSelected() | async) {
            <div class="warnings text-align-center">
                <p>{{ 'PayMultipleContractText_5' | translate : { max: maxContractsAllowed } }}</p>
            </div>
            }
            <div class="justify-content-center mt-2">
                <por-base-button [class]="'btn-primary'" [theme]="'primary'" [featureName]="'multipayment-panel-continue'" [disabled]="total < 1" (click)="onClickContinue()">
                    {{ 'Continue' | translate }}
                </por-base-button>
            </div>
        </div>
    </por-overlay>
</div>
}
<ng-template #selectedContract let-contracts>
    @if (contracts.length > 0) {
    <div class="selected-contracts">
        <h3>{{ 'SelectedContracts' | translate }}</h3>
        <table class="table">
            <thead>
                <tr>
                    <th>
                        <por-base-button
                            title="{{ 'Clear All' | translate }}"
                            [featureName]="'multipayment-panel-delete-all-contracts'"
                            icon="close"
                            [iconClass]="'font-18'"
                            [class]="'transparent'"
                            (onclick)="removeContracts(contracts)"></por-base-button>
                    </th>
                    <th>{{ 'Contract #' | translate }}</th>
                    <th>{{ 'Amount Due' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                @for (contract of contracts; track contract) {
                <tr>
                    <td>
                        <por-base-button
                            (onclick)="removeContracts(contract)"
                            [featureName]="'multipayment-panel-delete-contract'"
                            icon="close"
                            [iconClass]="'font-18'"
                            [class]="'transparent'"></por-base-button>
                    </td>
                    <td>{{ contract.contractId }}</td>
                    <td class="text-align-right">{{ contract.AmountDue | formatCurrency }}</td>
                </tr>
                }
            </tbody>
            <tfoot>
                <tr>
                    <th colspan="2">{{ 'TotalContracts' | translate }}</th>
                    <th class="text-align-right">{{ appFacadeService.getSelectedContractsTotal() | async | formatCurrency }}</th>
                </tr>
            </tfoot>
        </table>
    </div>
    }
</ng-template>
<ng-template #selectedCredits let-contracts>
    @if (contracts.length > 0) {
    <div class="selected-credits mt-1">
        <h3>{{ 'SelectedCredits' | translate }}</h3>
        <table class="table">
            <thead>
                <tr>
                    <th>
                        <por-base-button
                            title="{{ 'Clear All' | translate }}"
                            [featureName]="'multipayment-panel-delete-all-contracts'"
                            icon="close"
                            [iconClass]="'font-18'"
                            [class]="'transparent'"
                            (onclick)="removeContracts(contracts)"></por-base-button>
                    </th>
                    <th>{{ 'Contract #' | translate }}</th>
                    <th>{{ 'Credit' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                @for (contract of contracts; track contract) {
                <tr>
                    <td>
                        <por-base-button
                            (onclick)="removeContracts(contract)"
                            [featureName]="'multipayment-panel-delete-contract'"
                            icon="close"
                            [iconClass]="'font-18'"
                            [class]="'transparent'"></por-base-button>
                    </td>
                    <td>{{ contract.contractId }}</td>
                    <td class="text-align-right">{{ contract.AmountDue | formatCurrency }}</td>
                </tr>
                }
            </tbody>
            <tfoot>
                <tr>
                    <th colspan="2">{{ 'TotalCredits' | translate }}</th>
                    <th class="text-align-right">{{ appFacadeService.getSelectedCreditContractsTotal() | async | formatCurrency }}</th>
                </tr>
            </tfoot>
        </table>
    </div>
    }
</ng-template>
<ng-template #totalContracts>
    <div class="total-contracts-due mt-1">
        <table class="table">
            <tbody>
                <tr>
                    <th colspan="2" class="bg-black">{{ 'TotalDue' | translate }}</th>
                    <th class="text-align-right bg-black">{{ appFacadeService.getContractsTotal() | async | formatCurrency }}</th>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>
